import "./return-request-first-request-confirmation-modal.scss";

document.addEventListener("DOMContentLoaded", () => {
  const $togglesOpen = document.querySelectorAll(".js-request-confirmation-modal");
  const $modal = $("#return-request__first-request-confirmation");
  const $form = document.querySelector(".return-request .new_request_return");

  $togglesOpen.forEach(toggleOpen => {
    toggleOpen.addEventListener("click", () => {
      if ($form.reportValidity()) {
        $modal.modal("show");
        $modal.find("button").first().trigger("focus");
      }
    });
  });
});
